<template>
  <a-modal
    width="400px"
    :footer="null"
    :maskClosable="false"
    centered
    :visible="isVisible"
    @cancel="cancel"
    destroyOnClose
  >
    <div class="wrap">
      <p class="title">扫码上传照片</p>
      <div class="isQRfailure" @click="reflashQR" v-if="isQRfailure">
        <div>
          <img class="reflashIcon" src="../assets/reflash.png" alt />
          <div>当前二维码已失效</div>
          <div>请点击刷新</div>
        </div>
      </div>
      <div v-else>
        <div id="qrcode" ref="qrcode"></div>
      </div>
      <p class="tips">手机上传图片时请不要关闭弹窗</p>
    </div>
  </a-modal>
</template>
<script>
import QRCode from "qrcodejs2";
export default {
  name: "wapUpload",
  data() {
    return {
      link: "https://www.id-photo-verify.com/wapUploadImgToWeb",
      cid: null,
      ws: null,
      webSocketUrl: `wss://api.id-photo-verify.com/ws/file/`,
      isQRfailure: false,
    };
  },
  props: ["source_page", "isVisible", "makePicData"],
  watch: {
    isVisible(val) {
      if (val) {
        this.cid = this.createHash();
        this.createWebSocket(this.webSocketUrl + this.cid);
        this.isQRfailure = false;
        this.$nextTick(function () {
          this.createQRcode();
        });
      } else {
        this.ws.close();
      }
    },
  },
  methods: {
    cancel() {
      this.$emit("cancel");
    },
    createHash(hashLength) {
      return Array.from(Array(Number(hashLength) || 24), () =>
        Math.floor(Math.random() * 36).toString(36)
      ).join("");
    },
    reflashQR() {
      this.isQRfailure = false;
      this.createWebSocket(this.webSocketUrl + this.cid);
      this.$nextTick(function () {
        this.createQRcode();
      });
    },
    createQRcode() {
      let that = this;
      // console.log(
      //   `${this.link}?cid=${this.cid}&source_page=${this.source_page}${
      //     this.makePicData
      //       ? `&makePicData=${encodeURI(JSON.stringify(this.makePicData))}`
      //       : ""
      //   }`
      // );
      let qrcodecs = new QRCode(this.$refs.qrcode, {
        width: 116,
        height: 116, // 高度
        text: `${this.link}?cid=${this.cid}&source_page=${this.source_page}${
          this.makePicData
            ? `&makePicData=${encodeURI(JSON.stringify(this.makePicData))}`
            : ""
        }`,
      });
    },
    createWebSocket(url) {
      if ("WebSocket" in window) {
        // 打开一个 web socket
        var ws = new WebSocket(url);
        this.ws = ws;
        ws.onopen = () => {
          // Web Socket 已连接上，使用 send() 方法发送数据
          ws.send(JSON.stringify([this.cid]));
        };

        ws.onmessage = (evt) => {
          var received_msg = JSON.parse(evt.data);
          // console.log("数据已接收", received_msg);
          ws.close();
          // this.handleResult(received_msg);
          this.$emit("handleResult", received_msg);
        };

        ws.onclose = () => {
          // 关闭 websocket
          this.isQRfailure = true;
        };
      } else {
        // 浏览器不支持 WebSocket
        alert("您的浏览器不支持手机上传!");
      }
    },

    // wsOnOPen
  },
};
</script>
<style scoped>
.wrap {
  text-align: center;
}
.title {
  font-size: 16px;
  font-family: PingFangSC-Medium, PingFang SC;
  font-weight: 600;
  color: #303133;
  margin-bottom: 20px;
}
#qrcode,
.isQRfailure {
  width: 140px;
  height: 140px;
  padding: 12px;
  margin: 0 auto;
  border: 1px solid #e5e5ea;
  border-radius: 4px;
  display: flex;
  justify-content: center;
  color: #b2b2b3;
  font-size: 12px;
  display: flex;
  align-items: center;
  cursor: pointer;
}
.reflashIcon {
  width: 24px;
  margin-bottom: 16px;
}
.tips {
  font-size: 12px;
  color: #adadae;
  margin: 20px 0;
}
</style>